import React, { useEffect, useRef, useState } from "react";
import Hls from "hls.js";
import defaultAvatar from "../assets/profile.png";

const JoinLive = ({ playbackUrl, streamer }) => {
  const videoRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!playbackUrl) {
      setError("No playback URL found.");
      return;
    }

    const video = videoRef.current;
    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
      });
      hls.loadSource(playbackUrl);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        setIsLoading(false);
        video.play();
      });
      hls.on(Hls.Events.ERROR, (event, data) => {
        console.error("HLS.js Error:", data);
        setError("Unable to play stream.");
      });
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = playbackUrl;
      video.addEventListener("loadedmetadata", () => {
        setIsLoading(false);
        video.play();
      });
    } else {
      setError("Your browser does not support HLS playback.");
    }
  }, [playbackUrl]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-screen bg-black text-white">
      {error ? (
        <div className="text-red-500">{error}</div>
      ) : isLoading ? (
        <div>Loading live stream...</div>
      ) : (
        <>
          <video
            ref={videoRef}
            controls
            autoPlay
            playsInline
            muted={false}
            className="w-full h-[90vh] rounded-lg object-contain"
          />
          {streamer && (
            <div className="absolute top-5 left-5 flex items-center space-x-3 bg-black/50 px-4 py-2 rounded-full">
              <img
                src={streamer.profile_picture_url || defaultAvatar}
                alt="User"
                className="w-10 h-10 rounded-full"
              />
              <p className="text-lg font-semibold">
                {streamer.first_name} {streamer.last_name}
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default JoinLive;
